class Modifier {

    constructor(parameters) {
        this.parameters = parameters;
    }

    // TODO modifier is abstract but needs a compute(series) function, gg
    compute(series, periodicity) {

    }


}

export default Modifier;
